<template>
  <div class="echart" ref="echart" :style="echartStyle"></div>
</template>

<script>
import echart from "@/utils/echart";
export default {
  props: {
    echartStyle: {
      type: Object,
      default() {
        return { 
          width: '100%',
          height: '30px;'
         };
      },
    },
    datax: {
      type: Array,
      default() {
        return [];
      },
    },
    datay: {
      type: Array,
      default() {
        return [];
      },
    },
    isScale: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    options() {
      return {
        xAxis: {
          type: 'category',
          boundaryGap: false,
          show: false
        },
        yAxis: {
          type: 'value',
          show: false
        },
        grid: {
          show: false,
          top: "0%",
          left: '0%',
          right: "0%",
          bottom: "0%",
        },
        series: [
          {
            data: [100, 120, 100, 90, 30, 90, 130,100, 120, 100, 90, 30, 90, 0],
            type: 'line',
            areaStyle: {},
            symbol: 'none',
            smooth: true,
            itemStyle:{
              color: 'rgb(151,95,228)',
              borderColor:'#ccc',
              borderWidth: 0,
            }
          }
        ]
      }
    },
  },
  watch: {
    options: {
      handler() {
        this.init()
      },
      deep: true
    }
    
  },
  data() {
    return {};
  },
  methods: {
    init() {
      const divFef = this.$refs.echart;
      const { setData } = echart(divFef);
      setData(this.options);
    },
  },
  mounted() {
   this.init()
  },
};
</script>

<style lang="stylus" scoped></style>
